class ClickHandlerV2 {
    constructor() {

        document.addEventListener('click', this.handleClick.bind(this));
        document.addEventListener('DOMContentLoaded', this.onload.bind(this));
        this.cartRemoveItem();
    }

    onload() {
        this.checkCartOnLoad()
        this.cartUpdate();
    }

    handleClick(event) {
        this.customATC(event.target);
        this.quantityBtns(event.target);
    }

    cartRemoveItem() {

			window.addEventListener('aftersell-upcart:public-events:item-removed', (e) => {
				const item = e.detail?.item;
				const variantId = item?.variantId;
				const itemToUpdate = document.querySelector(`[data-variant-id="${variantId}"] span`); 
				itemToUpdate.innerText = cstmAtcBtnName_xx;
			});

    }

    cartUpdate() {
			window.addEventListener('aftersell-upcart:public-events:cart-updated', (e) => {
				const cart = e.detail?.cart;
				this.cartUpdateItem(cart.items);

			});
    }

    cartUpdateItem(cartItems) {
      cartItems.forEach((cartItem) => {
        const variantId = cartItem.variantId;
        const cartQuantity = cartItem.quantity;
    
        const variantData = variant_list.find((variant) => variant.id === variantId);
    
        if (variantData) {
          const button = document.querySelector(`button[data-variant-id="${variantId}"]`);
          const btnContainer = button?.closest('.atc-action-wrapper');
          const inputToUpdate = btnContainer?.querySelector('.qtt-input');
          let span = button.querySelector('span');
    
          if (button) {
           if (cartQuantity >= variantData.quantity) {
                if (variantData.continueSelling) {
                    span.textContent = cstmAtcBtnName_xx;
                } else {
                    span.textContent = "Out of stock!";
                    inputToUpdate.value = 0;
                }
            }else if(cartQuantity > variantData.quantity && variantData.continueSelling){
                span.textContent = cstmAtcBtnName_xx;
            } else {
                span.textContent = cstmAtcBtnName_xx;
            }
          }
        }
      });
    }

    quantityBtns(targetBtn){
			if (targetBtn.matches('.increment')) {
				const container = targetBtn.closest('.order-input-quantity');
				const quantity_input = container.querySelector('.qtt-input');
				quantity_input.value = parseInt(quantity_input.value || 0, 10) + 1;
				
			}
			if (targetBtn.matches('.decrement')) {
				const container = targetBtn.closest('.order-input-quantity');
				const quantity_input = container.querySelector('.qtt-input');
				quantity_input.value = Math.max(
					parseInt(quantity_input.value || 0, 10) - 1,
					parseInt(quantity_input.min || 0, 10) 
				);
			}
		}

    customATC(targetBtn){

      if (targetBtn.closest('.cstm-special-temp-atc')) {

          let variantId;
          let span;
          
          if (targetBtn?.matches('.cstm-special-temp-atc')) {
            const spanSelect = targetBtn?.querySelector('span');
            variantId = targetBtn?.getAttribute('data-variant-id');
            span = spanSelect;

          }else{
            const spanButtonContainer = targetBtn?.closest('.cstm-special-temp-atc');
            variantId = spanButtonContainer.getAttribute('data-variant-id');
            span = targetBtn;

          }

          const container = targetBtn?.closest('.atc-action-wrapper');
          const quantity_input_element = container.querySelector('.qtt-input');
          const quantity_input = parseInt(quantity_input_element.value, 10);

          if (variantId && quantity_input > 0) {
            let formData = {
                'items': [{
                    'id': variantId,
                    'quantity': quantity_input
                }]
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                if (!response.ok) {
									quantity_input_element.value = 0;
									span.innerText = 'Out of stock!';
									throw new Error(`HTTP error! status: ${response.status}`);

                }
                return response.json();
            })
            .then(data => {
                quantity_input_element.value = 0;
                span.innerText = 'Added to cart!';
                setTimeout(() => {
                    this.cartUpdate();
                    span.innerText = 'Add to cart';
                }, 2000);

            });
          }

        }
    }

    async checkCartOnLoad() {

        if (typeof variant_unavailable_list !== 'undefined' && variant_unavailable_list) {
            variant_unavailable_list.forEach(item => {
                const outOfStockItem = document.querySelector(`[data-variant-id="${item.id}"] span`); 
                outOfStockItem.innerText = 'Out of stock!'
            });
        }

        const endpoint = window.Shopify.routes.root + 'cart.js';
        try {
            const response = await fetch(endpoint, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }else{
                const data = await response.json();
                data.items.forEach(item => {
                    const outOfStockItem = variant_list.find(variantItem => variantItem.id === item.id);
                    if (outOfStockItem) {
                        if (outOfStockItem.quantity == item.quantity ) {
                            const buttonToUpdate = document.querySelector(`[data-variant-id="${item.id}"] span`); 
                            buttonToUpdate.innerText = 'Out of stock!'
                        }
                    }

                });
            }

        } catch (error) {
            console.error('Error fetching cart data XXX:', error);
        }
    }

}

const clickHandlerV2 = new ClickHandlerV2();
